import { Component, computed, inject, Input, model } from '@angular/core';
import { ModalService } from '../../../core/services/modal/modal.service';

@Component({
    selector: 'app-modal',
    imports: [],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.css'
})
export class ModalComponent {
  private modalService = inject(ModalService);

  _modalItems = model<any>();
  @Input() maxWidth: string = 'max-w-lg';

  isVisible = computed(
    () => this.modalService.modalVisibility()
  );

  close() {
    this.modalService.closeModal();
  }

  cancel() {
    this.close();
  }
}
